const StoneGallery = () => {
  const galleryItems = [
    {
      title: 'Retaining Walls',
      image: 'https://public.readdy.ai/ai/img_res/ea9c369fb58220a71adf0bfbd3463d53.jpg'
    },
    {
      title: 'Stone Patios',
      image: 'https://readdy.ai/api/search-image?query=elegant%20natural%20stone%20patio%20outdoor%20living%20space%20beautiful%20stonework%20furniture%20landscaping%20clean%20simple%20background%20high%20quality%20installation&width=800&height=600&seq=stone-gallery-2&orientation=landscape'
    },
    {
      title: 'Walkways',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20natural%20stone%20walkway%20path%20through%20garden%20landscaping%20professional%20masonry%20clean%20simple%20background%20high%20quality%20craftsmanship&width=800&height=600&seq=stone-gallery-3&orientation=landscape'
    },
    {
      title: 'Stone Veneer',
      image: 'https://readdy.ai/api/search-image?query=natural%20stone%20veneer%20exterior%20wall%20installation%20modern%20home%20architecture%20professional%20masonry%20work%20clean%20simple%20background%20high%20quality&width=800&height=600&seq=stone-gallery-4&orientation=landscape'
    },
    {
      title: 'Stone Steps',
      image: 'https://readdy.ai/api/search-image?query=natural%20stone%20steps%20outdoor%20staircase%20landscaping%20professional%20installation%20durable%20masonry%20clean%20simple%20background%20high%20quality%20craftsmanship&width=800&height=600&seq=stone-gallery-5&orientation=landscape'
    },
    {
      title: 'Custom Features',
      image: 'https://readdy.ai/api/search-image?query=custom%20natural%20stone%20feature%20decorative%20landscaping%20outdoor%20design%20professional%20masonry%20work%20clean%20simple%20background%20high%20quality%20installation&width=800&height=600&seq=stone-gallery-6&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-6">
            Our Stone Work
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our portfolio of completed stone projects. Each installation showcases 
            our commitment to quality, precision, and natural beauty.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryItems.map((item, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg cursor-pointer"
            >
              <div className="w-full h-80">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-2xl font-bold text-white">
                    {item.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StoneGallery;